// extracted by mini-css-extract-plugin
module.exports = {"primary":"#3c4f76","accent":"#e91e63","secondary":"#e0981c","tertiary":"#b43434","success":"#687b86","info":"#2196f3","warning":"#cf4f39","danger":"#fb8c00","error":"#e63838"};